import { NgClass } from '@angular/common';
import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    computed,
    forwardRef,
    input,
    model,
    signal,
    ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DEALER_THEME } from '@hyundai/shared-lib';
import { InputSelectWrapperComponent } from '../input-select-wrapper/input-select-wrapper.component';
import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';

type SelectValue = string | undefined;

@Component({
    standalone: true,
    imports: [NgClass, InputWrapperComponent, InputSelectWrapperComponent],
    selector: 'ui-input-select',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    templateUrl: './m020-c030-input-select.component.html',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InputSelectComponent), multi: true }],
})
export class InputSelectComponent implements ControlValueAccessor {
    formControl = input<FormControl>();

    options = input.required<Array<{ value: SelectValue; label: string }>>();
    label = input<string>();
    placeholder = input<string>();

    error = input(false, { transform: booleanAttribute });
    errorMsg = input<string>();

    dropdownAsOverlay = input(false, { transform: booleanAttribute });

    theme = input<DEALER_THEME>('light');

    open = signal(false);

    selected = model<SelectValue>();
    selectedLabel = computed(() => {
        return this.options().find((opt) => opt.value === this.selected());
    });

    disabled = model(false);
    withNullSelect = input(false, { transform: booleanAttribute });
    nullSelectCustomLabel = input('Option wählen');

    onChange?: (value: SelectValue) => void;
    onTouch?: () => void;

    writeValue(value: SelectValue) {
        this.selected.set(value);
    }

    registerOnChange(fn: (value: SelectValue) => void) {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void) {
        this.onTouch = fn;
    }

    setDisabledState?(isDisabled: boolean) {
        this.disabled.set(isDisabled);
    }

    setValue(value: string | undefined) {
        this.selected.set(value);
        this.open.set(false);
        this.onChange?.(value);
    }

    openSelect() {
        this.open.set(!this.open());
        this.onTouch?.();
    }
}
